import { createItem, readItems } from "@directus/sdk";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CourseModule from "../Components/Modules/ModuleList/CourseModule";
import TopicInterface from "../Interfaces/TopicInterface";
import LoadingModule from "../Components/Modules/ModuleList/LoadingModule";
import TestApi from "../Api/TestApi";
import { directus } from "../Api/FetchDirectus";
import ProgressScale from "../Components/UI/ProgressScale";

const ModulePage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [topicList, setTopicList] = useState<
    TopicInterface[] | Record<string, any>[]
  >([]);
  const courseInfo = JSON.parse(localStorage.getItem("courseInfo") || "[]");
  const moduleInfo = JSON.parse(localStorage.getItem("module_files") || "[]");
  const moduleScale = moduleInfo.scale || 0;
  const [maxScale, setMaxScale] = useState(moduleInfo.topic_count);
  const [moduleComplete, setModuleComplete] = useState(false);
  const completed = JSON.parse(localStorage.getItem("completed") || "{}") || {};
  const [testExist, setTestExist] = useState(false);

  const fetchTopicList = async () => {
    try {
      return await directus.request(readItems(`Topics`, { limit: -1 }));
    } catch (error: any) {
      sessionStorage.removeItem("token");
      navigate("/");
      return [];
    }
  };

  let contentList: TopicInterface[] | Record<string, any> = [];

  async function fetchTopics() {
    const list = [...(await fetchTopicList())];

    moduleInfo?.topics.forEach((item: number) => {
      list.forEach((topic) => {
        if (item === topic.id) {
          contentList.push(topic);
        }
      });
    });

    setTopicList([
      ...contentList.sort((a: TopicInterface, b: TopicInterface) =>
        a.topic_priority > b.topic_priority ? 1 : -1
      ),
    ]);
  }

  useEffect(() => {
    localStorage.setItem("topic_list", JSON.stringify(topicList));
  }, [topicList]);

  async function fetchTest() {
    const data = {
      sphere: "",
      position: "",
      competencies: moduleInfo.module_id ? [moduleInfo.module_id] : [0],
    };

    const startTest = await TestApi.startTest(data);

    if (startTest.message === "No questions found") {
      setTestExist(false);
    } else {
      if (startTest.status === 200) {
        localStorage.setItem("question", JSON.stringify(startTest.data));
        localStorage.setItem("session_code", startTest.sessionCode);
        localStorage.setItem(
          "total_question",
          JSON.stringify(startTest.totalQuestions)
        );
        localStorage.setItem("maxScore", JSON.stringify(startTest.maxScore));
        localStorage.removeItem("test_count");
        localStorage.removeItem("radar_data");
      }
      setTestExist(true);
    }
  }

  async function fetch() {
    setLoading(true);

    await fetchTopics();
    await fetchTest();

    setLoading(false);
  }

  useEffect(() => {
    fetch();

    let sortedList = topicList;

    sortedList.sort((a, b) => (a.priority > b.priority ? 1 : -1));

    setTopicList(sortedList);
  }, []);

  async function onTopicClick(
    content: TopicInterface | any,
    completeTopic: boolean
  ) {
    window.scrollTo(0, 0);

    localStorage.setItem(
      "topic_order",
      JSON.stringify(topicList.indexOf(content))
    );

    localStorage.setItem("complete_topic", JSON.stringify(completeTopic));

    localStorage.setItem("topic_files", JSON.stringify(content));

    const age = localStorage.getItem("age");
    const gender = localStorage.getItem("gender");
    const activity = localStorage.getItem("activity");
    const position = localStorage.getItem("position");

    navigate("/modules/module/topic");
    try {
      await directus.request(
        createItem("Course_History", {
          email: localStorage.getItem("email"),
          url: "/modules/module/topic",
          course: localStorage.getItem("courseInfo"),
          module: localStorage.getItem("module_files"),
          scales: localStorage.getItem("scales"),
          completed: localStorage.getItem("completed"),
          certificat_completed: localStorage.getItem("certificat_completed"),
          certificat_link: localStorage.getItem("certificat_link"),
          topic: JSON.stringify(content),
          date: JSON.stringify(new Date()),
          my_courses: localStorage.getItem("my_courses"),
          active_course: localStorage.getItem("active_course"),
          form: JSON.stringify({
            age: age,
            gender: gender,
            activity: activity,
            position: position,
          }),
        })
      );
    } catch (error: any) {
      sessionStorage.removeItem("token");
      navigate("/");
    }
  }

  // useEffect(() => {
  //   if (topicList.length === 1) {
  //     localStorage.setItem("topic_files", JSON.stringify(topicList[0]));
  //     navigate("/topic");
  //   }
  // }, [ topicList.length]);

  useEffect(() => {
    if (testExist) {
      setMaxScale(maxScale + 1);
    }
  }, [testExist]);

  useEffect(() => {
    if (
      completed &&
      completed?.[courseInfo.id] &&
      completed?.[courseInfo.id][moduleInfo.id] === ""
    ) {
      setModuleComplete(true);
    } else {
      setModuleComplete(false);
    }
  }, [completed]);

  return (
    <div className="coursesListPage">
      <div className="headModuleListBlock">
        <div className="headModuleBlock">
          {" "}
          <div className="courseBlockText testBlockText">
            <div>
              <h1>{moduleInfo.module_name}</h1>
              <div className="headCourseBlockDescription">
                {moduleInfo.module_description}
              </div>
            </div>
            <div className="courseInfo">
              <div>
                <p>Тем в модуле: </p>
                <p className="courseInfoContent"> {moduleInfo.topic_count}</p>
              </div>
              {/* <div>
                <p>Всего тестов:</p>
                <p className="courseInfoContent">{moduleInfo.test_count}</p>
              </div> */}
            </div>
            <div className="scalesBox">
              <div className="moduleScaleBox">
                <span>Прохождение модуля</span>
                {!loading && (
                  <ProgressScale
                    scale={
                      moduleInfo.scale
                        ? moduleComplete
                          ? maxScale
                          : moduleInfo.scale
                        : 0
                    }
                    max={maxScale}
                    color="#0D6EFD"
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="moduleList">
        {loading ? (
          [1, 1, 1].map(() => <LoadingModule />)
        ) : (
          <>
            {topicList.map((topic, index) => {
              return (
                <CourseModule
                  className={
                    index <= moduleScale
                      ? "courseModule"
                      : "courseModule disabledTopic"
                  }
                  key={index}
                  moduleTitle={topic.title}
                  head={topic.topic_name}
                  description={topic.topic_description}
                  callback={() => {
                    if (index <= moduleScale) {
                      window.scrollTo(0, 0);
                      onTopicClick(topic, index < moduleScale ? true : false);
                    }
                  }}
                />
              );
            })}
            {!testExist ? null : (
              <CourseModule
                className={
                  moduleScale >= maxScale - 1
                    ? "courseModule"
                    : "courseModule disabledTopic"
                }
                moduleTitle={"Тест"}
                head={"Тест по модулю"}
                description={
                  "Общее количество попыток и время прохождения не ограниченно."
                }
                callback={() => {
                  if (moduleScale >= maxScale - 1) {
                    navigate("/modules/module/test");
                  }
                }}
              ></CourseModule>
            )}
          </>
        )}
        {}
      </div>
    </div>
  );
};

export default ModulePage;
